import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import AboutUsLayout from "./Components/AboutUsLayout/AboutUsLayout";
import { ProductsLayout } from "./Components/ProductsLayout/ProductsLayout";
import ContactLayout from "./Components/ContactLayout/ContactLayout";
import ContactThankYouLayout from "./Components/ContactThankYouLayout/ContactThankYouLayout";
import ContactFormLayout from "./Components/ContactFormLayout/ContactFormLayout";
import { ProductsLayoutDetails } from "./Components/ProductsLayoutDetails/ProductsLayoutDetails";
import CustomNavbar from "./Components/Navbar";
import Footer from "./Components/Footer/Footer";
import CustomCursor from "./Components/CustomCursor/CustomCursor";
import ScrollReset from "./ScrollReset";
import { isMobileOrTablet } from "./utils/device";
import { useLocation } from "react-router-dom";
import { Fragment } from "react";

export const isMobile = window.innerWidth <= 768;
function App() {
  const location = useLocation();


  return (
    <Fragment>
      {!isMobileOrTablet() && <CustomCursor />}
      <ScrollReset />
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUsLayout />} />
        <Route path="/products" element={<ProductsLayout />} />
        <Route path="/products/:id" element={<ProductsLayoutDetails />} />
        <Route path="/contact" element={<ContactLayout />} />
        <Route path="/thank-you" element={<ContactThankYouLayout />} />
        <Route path="/contact-form" element={<ContactFormLayout />} />
      </Routes>
      {location.pathname !== "/about" && <Footer />}
    </Fragment>
  );
}

export default App;
